import Highcharts from 'highcharts';

export const figure23 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 300,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#5b9bd5', '#ed7d31'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ 
          "Mundo",
          "Australia y<br />Nueva Zelandia",
          "Asia central y<br />Asia meridional",
          "África<br />subsahariana",
          "América Latina y<br />el Caribe",
          "América del Norte y<br />Europa",
          "Oceanía<br />(excluidas<br />Australia y Nueva Zelandia)",
          "África septentrional y<br />Asia occidental",
          "Asia oriental y<br />Asia sudoriental",
         ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
            return this.value;
        },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 1.00,
        min: 0.00,
        tickInterval: 0.20,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: '2019',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 
          0.53,
          0.30,
          0.39,
          0.13,
          0.27,
          0.47,
          0.12,
          0.31,
          1.06,
           ],
      },
      {
        name: '2001',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[ 
          0.52,
          0.33,
          0.33,
          0.17,
          0.26,
          0.68,
          0.13,
          0.29,
          0.64,
           ]
      }
    ]
}